<app-header *ngIf="router.url != '/' && router.url != '/login' && router.url != '/error'"></app-header>
<app-sidebar *ngIf="router.url != '/' && router.url != '/home' && router.url != '/login' && router.url != '/error'"></app-sidebar>
<app-loading></app-loading>
<router-outlet></router-outlet>



